export * from './User';
export * from './AffiliateSources';
export * from './UserInteraction';

export type UserGender = 'female' | 'male' | 'non-binary';
